import { DataTypeBase } from './base/data-type-base';

export class DataType extends DataTypeBase { }